export const kUrlParamSource = 'source';
export const kUrlParamGameId = 'gameid';

export const kLaunchEventOverwolfStart = 'overwolfstartlaunchevent';
export const kLaunchEventGameLaunch = 'gamelaunchevent';
export const kRelaunch = 'relaunch';
export const kLaunchEventDockLaunch = 'dock';

// -----------------------------------------------------------------------------
export class OWExtensions {
  // ---------------------------------------------------------------------------
  public static launch(uid: string, parameter?: any): void {
    overwolf.extensions.launch(uid, parameter);
  }

  // ---------------------------------------------------------------------------
  public static async getExtraObject(pluginName: string): Promise<any> {
    return new Promise((resolve, reject) => {
      overwolf.extensions.current.getExtraObject(pluginName, res => {
        if (res.success) {
          resolve(res.object);
        } else {
          reject(res.error);
        }
      });
    });
  }

  // ---------------------------------------------------------------------------
  public static relaunch() {
    overwolf.extensions.relaunch();
  }
}
